import axios from "axios";

const BASE_URL = "https://api.myprintcircle.kopa.org.in/reactapp"
//const BASE_URL ="http://10.60.62.173:8000/reactapp"

const api = {
    loginApi: async (userid, password, requestData) => {
        try {
            const response = await axios.post(`${BASE_URL}/web_login`, { userid, password, ...requestData })
            return response.data
        } catch (error) {
            console.error("Login error:", error.message);
            throw error;
        }

    },
    userRegistration: async (requestData) => {
        try {
            const response = await axios.post(`${BASE_URL}/get_registration`, requestData)
            return response
        } catch (error) {
            console.error("User Registration", error.message)
            throw error;
        }
    },
    registrationApproveReject: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/registration_aprove_rectect`, payload)
            return response
        } catch (error) {
            console.error("Registration approve or reject ", error.message)
            throw error
        }
    },
    staffRegistrationApproveReject: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/staff_registration_aprove_rectect`, payload)
            return response
        } catch (error) {
            console.error("Staff Registration approve or reject ", error.message)
            throw error
        }
    },
    eventCreation: async (payload, headers) => {
        try {
            const response = await axios.post(`${BASE_URL}/event_creation`, payload, headers)
            return response
        } catch (error) {
            console.error("Event creation", error.message)
            throw error
        }
    },
    eventEdit: async (payload, headers) => {
        try {
            const response = await axios.post(`${BASE_URL}/event_edit`, payload, headers)
            return response
        } catch (error) {
            console.error("Event edit", error.message)
            throw error
        }
    },
    getEventCreation: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/get_events`, payload)
            return response

        } catch (error) {
            console.error("get event creation error", error.message)
        }
    },
    deleteEvent: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/delete_event`, payload)
            return response

        } catch (error) {
            console.error("event deletion error", error.message)
        }

    },
    sponsorDelete: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/sponsor_delete`, payload)
            return response

        } catch (error) {
            console.error("event sponsor deletion error", error.message)
        }
    },
    publishEvent: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/event_publish`, payload)
            return response
        } catch (error) {
            console.error("event publish error", error.message)
        }
    },
    categoryCreation: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/category_creation`, payload)
            return response
        } catch (error) {
            console.error("Category creation error", error.message)
        }
    },
    getCategoryList: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/get_category_data`, payload)
            return response

        } catch (error) {
            console.error("get category api error", error.message)
        }
    },
    deleteCategory: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/delete_category`, payload)
            return response

        } catch (error) {
            console.error("Delete Category api error", error.message)
        }
    },
    deleteSubCategory: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/delete_sub_category`, payload)
            return response
        } catch (error) {
            console.error("Delete Sub Category api error", error.message)
        }
    },
    getServicesProducts: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/get_services_products_data`, payload)
            return response

        } catch (error) {
            console.error("get Service Products api error", error.message)
        }
    },
    createServiceProduct: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/services_products_creation`, payload)
            return response

        } catch (error) {
            console.error(" Service Products api error", error.message)
        }
    },
    deleteServiceProduct: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/delete_products_creation`, payload)
            return response

        } catch (error) {
            console.error(" Deleting Service Products api error", error.message)
        }
    },
    getMasterDetails: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/get_master_details`, payload)
            return response

        } catch (error) {
            console.error("get master Details api error", error.message)
        }
    },
    verifyUser: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/verified_user`, payload)
            return response

        } catch (error) {
            console.error("Verify User api error", error.message)
        }
    },
    forumCreation: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/forum_creation`, payload)
            return response

        } catch (error) {
            console.error("Create Forum api error", error.message)
        }

    },
    getForumList: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/get_forum`, payload)
            return response
        } catch (error) {
            console.error("get Forum api error", error.message)
        }
    },
    deleteForum: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/delete_forum`, payload)
            return response
        } catch (error) {
            console.error("delete Forum api error", error.message)
        }
    },
    getErrorReports: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/report_or_complaints_view`, payload)
            return response
        } catch (error) {
            console.error("get Error report api error", error.message)
        }
    },
    sponsorCreation: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/sponsor_creation`, payload)
            return response
        } catch (error) {
            console.error("Sponsor creation error", error.message)
        }
    },
    getSponsorCreation: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/get_sponsor`, payload)
            return response
        } catch (error) {
            console.error("Get Sponsor error", error.message)
        }
    },
    deleteCreation: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/delete_sponsor`, payload)
            return response
        } catch (error) {
            console.error("Sponsor deletion error", error.message)
        }
    },
    brandCreation: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/brand_creation`, payload)
            return response
        } catch (error) {
            console.error("brand creation error", error.message)
        }
    },
    getBrand: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/get_brand`, payload)
            return response
        } catch (error) {
            console.error("get brand api error", error.message)
        }
    },
    deleteBrand: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/delete_brand`, payload)
            return response
        } catch (error) {
            console.error("delete brand api error", error.message)
        }
    },
    getEventRegistrationDetails: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/get_event_registration`, payload)
            return response
        } catch (error) {
            console.error("get event registration user details api error", error.message)
        }
    },
    ChangePassword: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/change_pwd`, payload)
            return response
        } catch (error) {
            console.error("Change password api error", error.message)
        }
    },
    getForumPostsApi: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/get_post_forum `, payload)
            return response
        } catch (error) {
            console.error("get forum posts api error", error.message)
        }
    },
    approveRejectForumPost: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/approve_recject_post_forum `, payload)
            return response
        } catch (error) {
            console.error("gapprove reject posts api error", error.message)
        }
    },
    activateSponsor: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/add_sponsor_for_register_user`, payload)
            return response
        } catch (error) {
            console.error("activate sponsor api error", error.message)
        }

    },
    pinForum: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/pin_forum`, payload)
            return response
        } catch (error) {
            console.error("Pin forum api error", error.message)
        }
    },
    closeForum: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/close_forum`, payload)
            return response
        } catch (error) {
            console.error("Close forum api error", error.message)
        }
    },

    donationCreation: async (payload) => {

        try {
            const response = await axios.post(`${BASE_URL}/donation_creation`, payload)
            return response
        } catch (error) {
            console.error("doantion creation api error", error.message);
        }
    },
    getdonation: async (payload) => {

        try {
            const response = await axios.post(`${BASE_URL}/get_donation`, payload)
            return response
        } catch (error) {
            console.error("get donation api error", error.message);
        }
    },
    deleteDonation: async (payload) => {

        try {
            const response = await axios.post(`${BASE_URL}/delete_donation`, payload)
            return response
        } catch (error) {
            console.error("delete donation api error", error.message);
        }
    },
    newsCreation: async (payload) => {

        try {
            const response = await axios.post(`${BASE_URL}/news_creation`, payload)
            return response
        } catch (error) {
            console.error("news creation api error", error.message);
        }
    },
    getnews: async (payload) => {

        try {
            const response = await axios.post(`${BASE_URL}/get_news`, payload)
            return response
        } catch (error) {
            console.error("get news api error", error.message);
        }
    },
    deleteNews: async (payload) => {

        try {
            const response = await axios.post(`${BASE_URL}/delete_news`, payload)
            return response
        } catch (error) {
            console.error("delete news api error", error.message);
        }
    },
    charityCreation: async (payload) => {

        try {
            const response = await axios.post(`${BASE_URL}/charity_creation`, payload)
            return response
        } catch (error) {
            console.error("charity creation api error", error.message);
        }
    },
    getCharity: async (payload) => {

        try {
            const response = await axios.post(`${BASE_URL}/get_charity`, payload)
            return response
        } catch (error) {
            console.error("get charity api error", error.message);
        }
    },
    deleteCharity: async (payload) => {

        try {
            const response = await axios.post(`${BASE_URL}/delete_charity`, payload)
            return response
        } catch (error) {
            console.error("delete charity api error", error.message);
        }
    },
    getMarketplace: async (payload) => {

        try {
            const response = await axios.post(`${BASE_URL}/get_market_place`, payload)
            return response
        } catch (error) {
            console.error("get market place api error", error.message);
        }
    },
    marketplaceApproveReject: async (payload) => {
        try {
            const response = await axios.post(`${BASE_URL}/market_place_approval_rejection`, payload)
            return response
        } catch (error) {
            console.error("market place approve or reject api error", error.message);
        }
    },
    getVendorDiscount: async (payload) => {

        try {
            const response = await axios.post(`${BASE_URL}/get_vendor_discount_data`, payload)
            return response
        } catch (error) {
            console.error("get vendor discount api error", error.message);
        }
    },
    vendorApproveReject: async (payload) => {

        try {
            const response = await axios.post(`${BASE_URL}/vendor_discount_approval_rejection`, payload)
            return response
        } catch (error) {
            console.error("get vendor discount approve reject api error", error.message);
        }
    },
    masterCreation: async (payload) => {

        try {
            const response = await axios.post(`${BASE_URL}/master_ades_creation`, payload)
            return response
        } catch (error) {
            console.error("master creation api error", error.message);
        }
    },
    getMasterData: async (payload) => {

        try {
            const response = await axios.post(`${BASE_URL}/get_ades_data`, payload)
            return response
        } catch (error) {
            console.error("get master api error", error.message);
        }
    },
    deleteMasterData: async (payload) => {

        try {
            const response = await axios.post(`${BASE_URL}/delete_ades`, payload)
            return response
        } catch (error) {
            console.error("delete master api error", error.message);
        }
    },

}



export default api;